<template>
  <div class="messages-page fullheight pos-relative">
    <Row class="fullheight">
      <i-col span="6" class="fullheight messages-list-col padding-20 pos-relative">
        <Input v-model="searchRfpNumber" prefix="md-search" placeholder="Search RFP number..." class="fullwidth k-input" clearable @on-clear="handleOnClear"/>
        <p class="text-center padding-t-20 centered" v-if="!rfpsMessages.length"><b>No messages yet</b></p>
        <RfpsMessagesCardList :messages="rfpsMessages" :active="selectedMessage" @change="handleOnChangeSelectedMessage"/>
      </i-col>
      <i-col span="18" class="fullheight message-info-col padding-20 pos-relative">
        <Row style="margin-bottom:20px;" :gutter="30" class="fullheight" v-if="Object.keys(selectedMessage).length">
          <Col span="16" class="fullheight">
            <RfpsMessage :message="selectedMessage"/>
          </Col>
          <Col span="8" class="fullheight">
            <RfpsMessageFiles :documents="selectedMessage.document"/>
          </Col>
        </Row>
        <p v-else class="text-center padding-t-20 centered"> No messages yet</p>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { fetchRfpsMessages } from '@/services/rfps-messages'
import RfpsMessage from '@/components/rfps-messages/RfpsMessage'
import RfpsMessageFiles from '@/components/rfps-messages/RfpsMessageFiles'
import RfpsMessagesCardList from '@/components/rfps-messages/RfpsMessagesCardList'

export default {
  components: {
    RfpsMessage,
    RfpsMessageFiles,
    RfpsMessagesCardList
  },

  data () {
    return {
      rfpsMessages: [],
      selectedMessage: {},
      searchRfpNumber: null
    }
  },

  mounted () {
    if (this.$route.query && this.$route.query.rfp) this.searchRfpNumber = this.$route.query.rfp
    this.getRfpsMessages()
  },

  watch: {
    searchRfpNumber (val) {
      this.getRfpsMessages()
    }
  },

  methods: {
    getRfpsMessages () {
      this.rfpsMessages = []
      let query = null
      if (this.searchRfpNumber) {
        query = `?keyword_search=${this.searchRfpNumber}`
      }
      fetchRfpsMessages(query).then(res => {
        if (res.data.length) {
          this.rfpsMessages = JSON.parse(JSON.stringify(res.data))
          this.rfpsMessages[0].unread_message_count = 0
          if (this.$route.query && this.$route.query.rfp) {
            const selected = res.data.find(x => x.rfp_number === this.$route.query.rfp)
            selected.company = { ...selected.company[0] }
            this.selectedMessage = { ...selected }
          } else {
            if (!this.selectedMessage.id) {
              const selected = Object.assign({}, res.data[0])
              selected.company = selected.company[0]
              this.selectedMessage = selected
            }
          }
        } else {
          this.rfpsMessages = []
          this.selectedMessage = {}
        }
      }).catch(err => {
        console.log('Failed to fetch rfps messages: ', err)
        this.rfpsMessages = []
        this.selectedMessage = {}
      })
    },

    handleOnChangeSelectedMessage (data, company) {
      this.getRfpsMessages()
      if (data.unread_message_count) {
        const fIdx = this.rfpsMessages.findIndex(x => (x.id === data.id && x.company === data.company))
        this.rfpsMessages[fIdx].unread_message_count = 0
      }
      this.selectedMessage = { ...data, company: company }
      if (this.$route.query && this.$route.query.rfp) this.$router.replace({ query: {} })
    },

    handleOnClear () {
      this.$router.replace({ query: null })
    }
  }
}
</script>

<style lang="scss" scoped>
.messages-page {
  .messages-list-col {
    background: #ffffff;
    box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, .07%);
  }
}
</style>
